<template>
    <div :class="['accept-page', noHead === 'true' ? 'no-header' : 'header-height']">
        <div class="head2">
            <div class="cup"></div>
            <div class="address">
                <div class="address-wrap" @click="showDetailAddress('origin')">
                    <span class="sender">寄</span>
                    <span class="p-holder">寄件地址</span>
                    <p class="input" :class="{ active: areaNameOrigin }">{{ areaNameOrigin + detailAddressOrigin }}</p>
                    <div v-show="!areaNameOrigin" class="p-select">请选择</div>
                    <icon class="ico-right" name="right"></icon>
                </div>
                <div class="address-wrap" @click="showDetailAddress('dest')">
                    <span class="receiver">收</span>
                    <span class="p-holder">收件地址</span>
                    <p class="input" :class="{ active: areaNameDest }">{{ areaNameDest + detailAddressDest }}</p>
                    <div v-show="!areaNameDest" class="p-select">请选择</div>
                    <icon class="ico-right" name="right"></icon>
                </div>
                <img src="@/assets/images/ico/v-dot.png" alt="分割线" />
            </div>
            <div class="detail">
                <div v-show="isIntl(rateCodeDest)" class="detail-item">
                    <div class="left">目的地邮编</div>
                    <div class="right">
                        <input v-model="zipCode" class="zip-input" type="number" />
                    </div>
                </div>
                <div class="detail-item" @click="showTimeCom">
                    <div class="left">寄件时间</div>
                    <div class="right">
                        <span>{{ timeDes || '一小时内' }}</span>
                        <icon class="ico-right" name="right"></icon>
                    </div>
                </div>
                <div class="detail-item">
                    <div class="left">重量</div>
                    <div class="right">
                        <div class="count">
                            <span class="act t-l" @click="changeWeight('minus')">-</span>
                            <span class="wrap">
                                <input v-model="weight" type="number" placeholder="重量" @keyup="clearNoNum('weight')" @blur="onBlur('weight')" />
                                <span class="unit">{{ areaCodeOrigin === 'A000001000' ? 'lbs' : 'kg' }}</span>
                            </span>
                            <span class="act" @click="changeWeight('add')">+</span>
                        </div>
                    </div>
                </div>
                <div class="detail-item">
                    <div class="left">体积</div>
                    <div class="right">
                        <div class="tiji">
                            <div class="wrap">
                                <input v-model="length" type="number" placeholder="长 (cm)" @keyup="clearNoNum('length')" />
                            </div>
                            <div class="wrap">
                                <input v-model="width" type="number" placeholder="宽 (cm)" @keyup="clearNoNum('width')" />
                            </div>
                            <div class="wrap">
                                <input v-model="height" type="number" placeholder="高 (cm)" @keyup="clearNoNum('height')" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <p class="demo-tip">注：录入货物尺寸预估收费更精准，若货物体积较大可能会按体积重量收费，详细规则可查阅下单界面—了解计费详情</p>
            <p class="button-wrapper">
                <button type="button" class="primary-btn" :disabled="!(areaNameOrigin && areaNameDest)" @click="query()">查询</button>
            </p>
            <div v-if="showProRes" class="price-result">
                <div class="des">以下为估算值（不包含包装及保价费），实际请以揽收为准</div>
                <div class="list">
                    <div class="tab">
                        <div class="left">
                            <div
                                v-for="item in shipTypes"
                                :key="item.name"
                                :class="['tab-item', { active: curShipType.name === item.name }]"
                                @click="changeShipType(item)"
                            >
                                {{ item.text }}
                            </div>
                        </div>
                        <div class="price-type" @click="changePriceType()">{{ priceType === 'origin' ? '寄付' : '到付' }}</div>
                    </div>
                    <div v-if="showHeavyTip" class="tip">20kg以上物品，使用大件(20kg+)运输服务更优惠。</div>
                    <div
                        v-show="(String(curShipType.code) !== '2' || (String(curShipType.code) === '2' && weight >= 20)) && !productList.length"
                        class="no-data"
                    >
                        暂无运效时费
                    </div>
                    <div v-if="String(curShipType.code) === '2' && weight < 20" class="no-data">20kg以下物品，请选择快递服务</div>
                    <div v-if="productList.length" class="product">
                        <div v-for="(product, index) in productList" :key="index" class="product-item">
                            <div class="name-wrap">
                                <div class="name">
                                    <!-- <span v-if="isIBU">{{ `${product.limitTypeName}（${product.cargoTypeName}）` }}</span> -->
                                    <span>{{ product.limitTypeName }}</span>
                                </div>
                                <img v-if="showOverItem(product)" src="@/assets/images/price/over.png" alt="超时" />
                            </div>
                            <div class="left">
                                {{ product.specialDisplay || product.deliverTimeText }}
                            </div>
                            <div class="right">
                                <div v-if="String(curShipType.code) !== '3'" class="right-item">
                                    <span class="unit">{{ product.currencyNameAbbr }}</span>
                                    <span class="price">
                                        <span>{{ product.totalFreight }}</span>
                                    </span>
                                    <span>起</span>
                                </div>
                                <div
                                    v-if="
                                        String(curShipType.code) !== '3' &&
                                        ((priceType === 'origin' && product.isChinaExpress) ||
                                            (priceType !== 'origin' && product.isMainlandExpress)) &&
                                        product.regionFreight &&
                                        Number(product.regionFreight) < 0
                                    "
                                    class="right-item"
                                >
                                    <span class="red">已优惠</span>
                                    <span>
                                        <span class="unit">{{ product.currencyNameAbbr }}</span>
                                        <span class="price">{{ Math.abs(Number(product.regionFreight)) || '' }}</span>
                                    </span>
                                </div>
                                <div
                                    v-if="String(curShipType.code) === '3' && (product.pickupFreight || product.destPickupFreight)"
                                    class="right-item"
                                >
                                    <span class="">提货费</span>
                                    <span>
                                        <span class="unit">{{ product.currencyNameAbbr }}</span>
                                        <span class="price">{{ product.pickupFreight }}</span>
                                    </span>
                                    <span>起</span>
                                </div>
                                <div
                                    v-if="String(curShipType.code) === '3' && (product.transportFreight || product.destTransportFreight)"
                                    class="right-item"
                                >
                                    <span class="">运输费</span>
                                    <span>
                                        <span class="unit">{{ product.currencyNameAbbr }}</span>
                                        <span class="price">{{ product.transportFreight }}</span>
                                    </span>
                                    <span>起</span>
                                </div>
                                <div
                                    v-if="String(curShipType.code) === '3' && (product.distributionFreight || product.destDistributionFreight)"
                                    class="right-item"
                                >
                                    <span class="">配送费</span>
                                    <span>
                                        <span class="unit">{{ product.currencyNameAbbr }}</span>
                                        <span class="price">{{ product.distributionFreight }}</span>
                                    </span>
                                    <span>起</span>
                                </div>
                            </div>
                            <div v-if="product.priceDetail" class="introduce" v-html="product.priceDetail.replace(/\n/g, '</br>')"></div>
                            <div class="freight-button" @click="showMoreFreight(product)">
                                预估详情
                                <icon name="information" class="icon-information"></icon>
                                <span class="tip-des"> {{ getTipDes(product) }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="showOverDes" class="others" @click="goRule('over')">
                        支付超时退费<icon class="ico-right" name="right"></icon
                        ><img class="over" src="@/assets/images/price/over.png" alt="支付超时退费" />
                    </div>
                    <div class="others" @click="goRule()">运费时效说明<icon class="ico-right" name="right"></icon></div>
                </div>
            </div>
            <div v-if="quick.show" class="quick-question-ask">
                <div class="title">您对我们的查询结果还满意吗？</div>
                <div class="choose">
                    <div
                        v-show="!quick.result || quick.result === 'no'"
                        class="no"
                        :class="{ active: quick.result === 'no', 'mr-8': !quick.result }"
                        @click="quickChoose('no')"
                    >
                        <div class="icon"></div>
                        <p>不满意</p>
                    </div>
                    <div
                        v-show="!quick.result || quick.result === 'yes'"
                        class="yes"
                        :class="{ active: quick.result === 'yes' }"
                        @click="quickChoose('yes')"
                    >
                        <div class="icon"></div>
                        <p>棒棒哒</p>
                    </div>
                </div>
                <div v-if="quick.result === 'no'" class="no-reason">
                    <div class="title">
                        <div class="line"></div>
                        <p>您不满意的地方是？</p>
                        <div class="line"></div>
                    </div>
                    <div class="btns">
                        <button :class="{ active: quick.reason.trouble }" @click="getNoReason('trouble')">操作麻烦</button>
                        <button :class="{ active: quick.reason.wrong }" @click="getNoReason('wrong')">结果有误</button>
                        <button :class="{ active: quick.reason.expensive }" @click="getNoReason('expensive')">费用太贵</button>
                    </div>
                    <p class="other">其他</p>
                    <div class="other-detail">
                        <textarea v-model="quick.reason.other" type="text" placeholder="请输入相关描述" maxlength="50"></textarea>
                        <p>{{ quick.reason.other.length }}/50</p>
                    </div>
                    <button class="submit" @click="quickQuestionSubmit">提交</button>
                </div>
            </div>
        </div>
        <time-picker-component
            v-if="showTime || timeFirst"
            :isFirst="timeFirst"
            :dayIndex="dayIndex"
            :timeIndex="timeIndex"
            @on-close="onTimeClose"
        ></time-picker-component>
        <drag-component v-if="noShip === 'false'" :config="dragConfig">
            <div @click="toShip">
                <div class="overlay-ship">前往寄件<icon class="ico-right" name="right"></icon></div>
            </div>
        </drag-component>
        <!-- 地址选择 -->
        <transition name="fade">
            <div v-show="isShowDetailAddress" class="detail-ddress">
                <div class="address-title">
                    <div class="address-close" @click.prevent="detailAddressClose"></div>
                    <div class="title-text">{{ addressText }}件地址填写</div>
                    <div class="blank"></div>
                </div>
                <div class="address address-select">
                    <div class="address-wrap" @click="toggleSelector">
                        <span class="p-holder">城市区域</span>
                        <p class="input" :class="{ active: addressSelectCommon.areaNameCommon }">{{ addressSelectCommon.areaNameCommon }}</p>
                        <div v-show="!addressSelectCommon.areaNameCommon" class="p-select">请选择</div>
                        <icon class="ico-right" name="right"></icon>
                    </div>
                    <textarea v-model="addressSelectCommon.detailAddressCommon" type="text" placeholder="详细地址(精确到门牌号)"></textarea>
                    <i class="ico-location"></i>
                </div>
                <div class="address-search">
                    <div class="btn-confirm" :class="{ active: addressSelectCommon.areaNameCommon }" @click.prevent="addressSearch">
                        <span>查询</span>
                    </div>
                </div>
            </div>
        </transition>
        <!-- 城市选择 -->
        <overlay
            :isShow.sync="isShowSelector"
            :finished.sync="selectCompleted"
            :enableBtn="enableBtn"
            :hasValid="hasSelectValidator"
            :cbValid="validSelector"
        >
            <h3 class="head">地区选择</h3>
            <ul class="rgn-tab">
                <li v-for="(item, idx) in regionTabs" :key="item.id" @touchstart.stop="toggleTab(idx)">
                    <div class="btn-tab" :class="{ active: regionTabIndex === idx }">{{ item.name }}</div>
                </li>
            </ul>
            <div class="search-form">
                <input
                    v-model="inputTxt"
                    type="text"
                    class="search"
                    :placeholder="placeholderTxt"
                    @input="inputChange"
                    @click="searchInputFocus"
                    @blur="searchInputBlur"
                />
                <i class="icon-search"></i>
                <i v-if="inputTxt" class="icon-close" @click.prevent="clear"></i>
            </div>
            <form @submit.prevent="submitSelect">
                <div v-if="!searchAddressList.length">
                    <div v-if="regionTabIndex === 0">
                        <area-inland
                            page="accept"
                            :area="area"
                            :isDest="type !== 'origin'"
                            :updateAreaCode="updateAreaCode"
                            :updateArea="updateArea"
                            :updateSelect="updateSelect"
                        />
                    </div>
                    <div v-if="regionTabIndex === 1">
                        <area-hmt
                            page="accept"
                            :area="area"
                            :max-level="2"
                            :updateAreaCode="updateAreaCode"
                            :updateArea="updateArea"
                            :isDest="type !== 'origin'"
                            :updateSelect="updateSelect"
                            :provinces="intlProvinces"
                        />
                    </div>
                    <div v-if="regionTabIndex === 2">
                        <area-intl
                            :area="area"
                            :updateArea="updateArea"
                            :input="inputTxt"
                            :updateCityCode="updateCityCode"
                            :updateAreaCode="updateAreaCode"
                            :zipCode="zipCode"
                            :isDest="type !== 'origin'"
                            :updateZipCode="updateZipCode"
                            :updateSelect="updateSelect"
                            :provinces="intlProvinces"
                        />
                    </div>
                </div>
                <ul v-else class="search-address-region">
                    <li
                        v-for="(item, index) in searchAddressList"
                        :key="index"
                        :class="{ active: index === selectedItemIndex }"
                        @click="selectedSearchAddress(item, index)"
                        v-html="item.html"
                    ></li>
                </ul>
            </form>
            <slot slot="button" slot-scope="props">
                <div ref="btnConfirm" class="btn-confirm" :class="{ active: props.active }">
                    <span>确认</span>
                </div>
            </slot>
        </overlay>
        <div v-show="Object.keys(showPriceDetailProduct).length > 0" class="freight-detail">
            <div class="center-middle">
                <h4>运费预估</h4>
                <div class="freight-wrap">
                    <p class="detail-item">
                        <span>计费重量</span>
                        <span>{{ `${showPriceDetailProduct.weight}${areaCodeOrigin === 'A000001000' ? 'lbs' : 'kg'}` }}</span>
                    </p>
                    <p class="detail-item">
                        <span>基础运费</span>
                        <span>{{ showPriceDetailProduct.currencyNameAbbr }}{{ showPriceDetailProduct.baseFreight }}</span>
                    </p>
                    <p v-for="freightPriceItem in showPriceDetailProduct.freightPriceItemList" :key="freightPriceItem.code" class="detail-item">
                        <span>{{ freightPriceItem.name }}</span>
                        <span>{{ showPriceDetailProduct.currencyNameAbbr }}{{ freightPriceItem.price }}</span>
                    </p>
                </div>
                <div class="freight-close" @click="showPriceDetailProduct = {}">我知道了</div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { RegionGroup } from '@/constant/common'
import ibuCountry from '@/constant/ibuCountry'
import InlandCitySelector from '@/components/citySelector/area-inland'
import IntlCitySelector from '@/components/citySelector/area-intl'
import timePickerComponent from '@/components/time-picker'
import HMTCitySelector from '@/components/citySelector/area-hmt'
import Overlay from '@/components/citySelector/overlay/'
import ajax from '../../api/ajax'
import { Indicator } from 'mint-ui'
import mixCitySelector from '@/components/citySelector/mixin'
import { shipTypes, additionalServiceList, checkCountry, serviceItemSortObj } from './config'
import dragComponent from '@/components/common/drag'
import loginType from '@/constant/loginType'
import { urls } from '@/constant/paths'
import { jump } from '@/mixins/pageJump/'
import { add, subtraction } from '@/constant/caculate/'
import UIP from '@/util/uip.js'
import { getHighHtml } from '@/util/util.js'
import { PRODUCT } from '@uip-alpha/business-constants'

export default {
    name: 'Price',
    components: {
        'area-inland': InlandCitySelector,
        'area-intl': IntlCitySelector,
        'area-hmt': HMTCitySelector,
        overlay: Overlay,
        timePickerComponent,
        dragComponent
    },
    mixins: [mixCitySelector],
    props: {
        // 是否隐藏头部
        noHead: {
            type: String,
            default: 'false'
        },
        noShip: {
            type: String,
            default: 'false'
        },
        noFooter: {
            type: String,
            default: 'false'
        }
    },
    data() {
        return {
            isShowSelector: false, // 是否显示城市选择框
            isShowSelector2: false,
            isShowDetailAddress: false,
            enableBtn: false, // 选择结束，激活按钮
            selectCompleted: false, // 选择是否完成
            regionTabIndex: 0, // 范围选择项(大陆、港澳台、国际)
            regionTabIndexO: 0,
            regionTabIndexD: 0,
            selectorValidResult: '', // 选择器验证结果
            isShowResult: false,
            rangeData: {
                unavailableRegions: [], // 不服务地区
                normalRegions: [], // 正常收送地区
                abnormalRegions: [], // 特别收送地区
                type: '' // ALL_REGION,全境提供服务; PART_REGION,部分地区提供服务;
            },
            addressSelectCommon: {
                areaNameCommon: '',
                detailAddressCommon: '',
                countryCode: '',
                rateCode: '',
                code: '',
                area: '',
                index: 0,
                cityCode: ''
            },
            addressText: '寄',
            areaName: '国家/地区选择', // 选择地址名
            zipCode: '',
            areaCodeOrigin: '',
            areaCodeDest: '',
            rateCodeOrigin: '',
            rateCodeDest: '',
            villageFlag: null,
            villageTownDist: null,
            areaNameOrigin: '',
            detailAddressOrigin: '',
            areaNameDest: '',
            detailAddressDest: '',
            cityCodeOrigin: '',
            cityCodeDest: '',
            countryCodeOrigin: '',
            countryCodeDest: '',
            srcZoneCode: '',
            destZoneCode: '',
            countryList: [], // 同步cx已开放的国际国家json数据
            intlProvinces: [], // 国际城市信息
            inputTxt: '', // 搜索框输入文案
            searchAddressList: [], // 搜索结果列表
            selectedItemIndex: -1, // 搜索结果选中索引
            article: '', // 物品
            buttonDisabled: true,
            selectedDest: {
                cnName: '',
                shortName: '',
                info: ''
            },
            area: {},
            areaOrigin: {},
            areaDest: {},
            type: 'origin',
            result: [],
            showResult: false,
            showPopResult: false,
            hasNoMore: true,
            length: '',
            weight: '1',
            width: '',
            height: '',
            showTime: false,
            time: '',
            dayIndex: 0,
            timeIndex: 0,
            timeDes: '',
            timeFirst: true,
            shipTypes,
            curShipType: shipTypes[0],
            productList: [],
            priceType: 'origin',
            showProRes: false,
            dragConfig: {
                onlyRight: true,
                top: 'auto',
                left: 'auto',
                right: '0',
                bottom: '.98rem',
                width: '1.94rem', // 拖拽元素宽
                height: '0.83rem', // 拖拽元素高
                side: true, // 自动靠边
                zIndex: 3, // 拖拽元素层级
                winWidth: 375 // 窗口宽度 ios outerWidth 为0 需要用innerWidth替代
            },
            smallPro: false,
            // 快问快答
            quick: {
                first: true,
                show: false,
                result: '',
                reason: {
                    trouble: false,
                    wrong: false,
                    expensive: false,
                    other: ''
                }
            },
            showPriceDetailProduct: {}
        }
    },
    computed: {
        selectedOriginName() {
            return ''
        },
        selectedDestName() {
            return ''
        },
        regionTabs() {
            return RegionGroup.regionTabs
        },
        isAllService() {
            return this.rangeData.type === 'ALL_REGION'
        },
        unavailableRegionsNames() {
            const names = this.rangeData.unavailableRegions.map(item => item.name)
            return names.join('-')
        },
        isInternational() {
            return this.regionTabIndex === 2
        },
        isUSA() {
            return this.areaCode === 'A000001000'
        },
        hasSelectValidator: {
            // 选择器是否有验证规则
            get() {
                return this.isInternational
            }
        },
        showHeavyTip() {
            return (
                String(this.curShipType.code) === '1' &&
                this.weight >= 20 &&
                UIP.utils.check.AREA.isCHN(this.rateCodeOrigin) &&
                UIP.utils.check.AREA.isCHN(this.rateCodeDest)
            )
        },
        showOverDes() {
            return (
                this.productList.findIndex(
                    item =>
                        item.additionalService &&
                        item.additionalService.length &&
                        item.additionalService.findIndex(item => item.code === 'overdue-refund') > -1
                ) > -1
            )
        },
        /**
         * 根据范围选择项动态匹配输入框默认文案
         */
        placeholderTxt() {
            return (
                new Map([
                    [0, '请输入地区名进行搜索'],
                    [1, '请输入地区名进行搜索'],
                    [2, '请输入国家名进行搜索']
                ]).get(this.regionTabIndex) || '请输入地区名进行搜索'
            )
        },
        /**
         * 行政区的 regionKey
         */
        regionKey() {
            return (
                new Map([
                    [0, 'local_region_cn_sc'],
                    [1, 'local_region_hk_mo_tw_sc'],
                    [2, 'local_ibu_hotcounties_sc']
                ]).get(this.regionTabIndex) || 'local_region_cn_sc'
            )
        },
        isIBU() {
            return this.isIntl(this.rateCodeDest) || this.isIntl(this.rateCodeOrigin)
        }
    },
    watch: {
        selectCompleted(val) {
            if (val && !this.isInternational) {
                // this.getRange()
            }
        },
        inputTxt(val) {
            if (!val) {
                this.clear()
            }
        },
        regionTabIndex(val) {
            // 大陆和港澳台通过uip查询，国际直接从已有数据中筛选
            if (val === 2) {
                return (this.searchAddressList = [])
            }
            if (this.inputTxt) {
                this.inputChange()
            }
        },
        isShowSelector(val) {
            // 重新打开窗口清空搜索记录
            if (val) {
                return (this.inputTxt = '')
            }
            this.selectedItemIndex = -1
        },
        // 寄件地址变化清空收件地址信息
        areaNameOrigin() {
            this.areaCodeDest = ''
            this.areaNameDest = ''
            this.countryCodeDest = ''
        }
    },
    mounted() {
        this.timeFirst = false
        window.addEventListener('resize', this.resizeHeight, false)
    },
    created() {
        this.setTitle('运费时效查询')
        this.setShowHeader(!(this.noHead === 'true'))
        this.setShowFooter(!(this.noFooter === 'true'))
        // 获取国外已开放国家js数据
        this.countryList = ibuCountry.countryList
        // 取出国家code码，与接口返回的国际国家数据取交集，使用接口返回的国家数据
        const countryCodeList = []
        this.countryList.forEach(value => {
            countryCodeList.push(value.code)
        })
        // this.getRegion({ code: 'A000000000' }).then((provinces) => {
        //   this.intlProvinces = provinces
        // })
        this.setShowCustomer(true)
        // eslint-disable-next-line no-undef
        wx.miniProgram.getEnv(res => {
            this.smallPro = !!res.miniprogram
        })
    },
    beforeDestroy() {
        // 销毁前解绑
        window.removeEventListener('resize', this.resizeHeight, false)
    },
    methods: {
        ...mapMutations('range', {
            setSelectorValid: 'setSelectorValid',
            setAreaData: 'setAreaData',
            setAreaDataDest: 'setAreaDataDest'
        }),
        ...mapMutations(['setShowCustomer']),
        ...mapMutations({
            setTitle: 'setTitle',
            setShowHeader: 'setShowHeader',
            setShowFooter: 'setShowFooter'
        }),
        /**
         * 页面resize响应的事件函数
         * **/
        resizeHeight() {
            const winScreenHeight = document.documentElement.clientHeight || document.body.clientHeight
            if (winScreenHeight > this.screenHeight) {
                // 键盘收起
                this.selectClass = ''
            }
            this.screenHeight = document.documentElement.clientHeight || document.body.clientHeight
        },
        onBlur(type) {
            if (type === 'weight') {
                if (Number(this.weight < 1)) {
                    this.weight = 1
                }
            }
        },
        changeShipType(item) {
            if (item.name === this.curShipType.name) {
                return
            }
            this.curShipType = item
            // this.showProRes = false
            this.query()
        },
        toShip() {
            this.setShowHeader(false) // 隐藏公共的头部
            if (this.smallPro) {
                setTimeout(() => {
                    // eslint-disable-next-line no-undef
                    wx.miniProgram.navigateTo({
                        url: `/pages/order/sending/order-home/order-home?type=${String(this.curShipType.code) === '2' ? 'large' : 'normal'}`, // 跳转回小程序的页面,传参id, 小程序onLoad函数接收参数即可
                        success: () => {
                            console.log('success')
                        },
                        fail: () => {
                            console.log('跳转回小程序的页面fail')
                        }
                    })
                }, 1500)
            } else {
                const urlConfig = {
                    owfUrl: `/mobile/cn/sc/login?type=${loginType.WX_ORDER}`,
                    cxUrl: `${urls.MP_CHECK_TICKET}?type=${loginType.WX_ORDER}`
                }
                jump(urlConfig)
            }
        },
        showOverItem(item) {
            return (
                item.additionalService &&
                item.additionalService.length &&
                item.additionalService.findIndex(item => item.code === 'overdue-refund') > -1
            )
        },
        changePriceType() {
            //   return
            this.priceType = this.priceType === 'origin' ? 'dest' : 'origin'
            this.query()
        },
        isIntl(rateCode) {
            const pattern = new RegExp('[A-Za-z]+')
            return pattern.test(rateCode)
        },
        onTimeClose(data) {
            this.showTime = false
            if (data) {
                this.time = data.time
                this.timeIndex = data.selectedTimeIndex
                this.dayIndex = data.selectedDayIndex
                this.timeDes = data.timeDes
            }
        },
        goRule(str) {
            this.$router.push({
                path: '/cn/sc/price/rule',
                query: {
                    type: str,
                    noHead: this.noHead
                }
            })
        },
        // 点击输入框时处理安卓 键盘挡住问题
        searchInputFocus() {
            const timerFocus = setTimeout(() => {
                timerFocus && clearTimeout(timerFocus)
                this.selectClass = 'select-rel'
                document.body.scrollTop = 0
                // 如果document.body.scrollTop始终为0，用document.documentElement.scrollTop代替
                document.documentElement.scrollTop = 0
                window.scrollTo && scrollTo(0, 0)
            }, 500)
        },
        /**
         * 选中某一项返回接口查询结果
         */
        selectedSearchAddress(item, index) {
            this.enableBtn = true
            const resultCounty = item.county ? `${item.county}` : (this.selectedItemIndex = index)
            this.updateAreaCode({
                code: item.countyCode || item.cityCode,
                areaName: `${item.province}${item.city}${resultCounty}`,
                rateCode: item.locationCode,
                countryCode: item.countryCode
            })
            // // 澳门-环路可能只有两级 如果没有 countryCode 则取 cityCode
            // this[this.type === 'origin' ? 'areaCodeOrigin' : 'areaCodeDest'] = item.countyCode || item.cityCode
            // const resultCounty = item.county ? `-${item.county}` : ''
            // this[this.type === 'origin' ? 'areaNameOrigin' : 'areaNameDest'] = `${item.province}-${item.city}${resultCounty}`
            // uip查询结果和接口返回结构不同，这里需要对省市区三级重新做赋值
            this[this.type === 'origin' ? 'setAreaData' : 'setAreaDataDest']({
                province: {
                    name: item.province,
                    code: item.provinceCode
                },
                city: {
                    name: item.city,
                    code: item.cityCode
                },
                country: {
                    name: item.county,
                    code: item.countyCode
                }
            })
        },
        searchInputBlur() {
            const timerBlur = setTimeout(() => {
                timerBlur && clearTimeout(timerBlur)
                this.selectClass = ''
            }, 500)
        },
        showTimeCom() {
            this.showTime = true
        },
        clearNoNum(type) {
            this[type] = String(this[type])
            let str = this[type]
            str = str.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
            str = str.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
            str = str.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
            str = str.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
            if (str.indexOf('.') < 0 && str != '') {
                // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                str = parseFloat(str)
            }
            if (Number(str) > 9999) {
                str = '9999'
            }
            this[type] = str
        },
        /**
         * 模糊匹配
         */
        async inputChange() {
            if (this.inputTxt) {
                const options = {
                    regionKey: this.regionKey,
                    count: '1000'
                }
                // this.searchAddressList = await this.$I.region.search(
                //   this.inputTxt,
                //   options
                // )
                this.searchAddressList = await UIP.interface.region.search(this.inputTxt, options)
                this.searchAddressList.forEach(item => {
                    const str = [item.province, item.city, item.county].filter(item => !!item).join('-')
                    item.html = getHighHtml(str, this.inputTxt)
                    item.cityCode = item.countyAreaCode || ''
                    item.countyCode = item.countyAreaCode || ''
                    item.locationCode = item.countyLocationCode || item.cityLocationCode || item.provinceLocationCode || ''
                    item.provinceCode = item.provinceAreaCode || ''
                    item.countryCode = item.countryCode
                })
            }
        },
        /**
         * 清空搜索数据
         */
        clear() {
            this.selectedItemIndex = -1
            this.searchAddressList = []
            this.inputTxt = ''
        },
        submitSelect() {
            const event = document.createEvent('Events')
            event.initEvent('touchstart', true, true)
            this.$refs.btnConfirm.dispatchEvent(event)
        },
        async validSelector() {
            if (this.isInternational) {
                // const code = this.zipCode
            }
            this.setSelectorValid(true)
            return true
        },
        changeWeight(type) {
            if (type === 'add') {
                this.weight = String(add(Number(this.weight), 1))
                if (Number(this.weight) > 9999) {
                    this.weight = 9999
                }
            } else if (type === 'minus') {
                this.weight = String(subtraction(Number(this.weight), 1))
                if (Number(this.weight) < 1) {
                    this.weight = 1
                }
            }
        },
        updateAreaCode({ code, areaName, rateCode, countryCode }) {
            this.addressSelectCommon.code = code
            this.addressSelectCommon.rateCode = rateCode
            this.addressSelectCommon.countryCode = countryCode
            this.addressSelectCommon.areaNameCommon = areaName
            if (this.type === 'dest') {
                this.zipCode = ''
            }
            this.showProRes = false
        },
        updateCityCode(cityCode) {
            this.addressSelectCommon.cityCode = cityCode
        },
        updateZipCode(data) {
            if (this.type !== 'origin') {
                this.zipCode = data
            }
        },
        updateArea(data) {
            this.addressSelectCommon.area = data
        },
        updateSelect(val) {
            this.enableBtn = !!val
        },
        toggleTab(index) {
            if (this.regionTabIndex !== index) {
                this.enableBtn = false
            }
            this.addressSelectCommon.index = index
            this.regionTabIndex = index
            this.selectedItemIndex = -1
        },
        toggleSelector() {
            this.isShowSelector = true
            this.enableBtn = false
        },
        showDetailAddress(type) {
            this.type = type
            if (this.type === 'origin') {
                this.addressText = '寄'
                this.addressSelectCommon.code = this.areaCodeOrigin
                this.addressSelectCommon.rateCode = this.rateCodeOrigin
                this.addressSelectCommon.countryCode = this.countryCodeOrigin
                this.addressSelectCommon.cityCode = this.cityCodeOrigin
                this.addressSelectCommon.areaNameCommon = this.areaNameOrigin
                this.area = this.areaOrigin
                this.regionTabIndex = this.regionTabIndexO
                this.addressSelectCommon.detailAddressCommon = this.detailAddressOrigin
                this.getRegion({ code: 'A000000000' }).then(provinces => {
                    this.intlProvinces = provinces
                })
            } else {
                if (!this.areaNameOrigin) {
                    return this.$toast('请选择始发地国家/地区名称')
                }
                this.addressText = '收'
                this.addressSelectCommon.code = this.areaCodeDest
                this.addressSelectCommon.rateCode = this.rateCodeDest
                this.addressSelectCommon.countryCode = this.countryCodeDest
                this.addressSelectCommon.cityCode = this.cityCodeDest
                this.addressSelectCommon.areaNameCommon = this.areaNameDest
                this.area = this.areaDest
                this.regionTabIndex = this.regionTabIndexD
                this.addressSelectCommon.detailAddressCommon = this.detailAddressDest
                this.getDestRegion({ code: this.areaCodeOrigin }).then(provinces => {
                    this.intlProvinces = provinces
                })
            }
            this.isShowDetailAddress = true
        },
        async outOfRange(addressSelectCommon) {
            const result = await ajax
                .queryAppointment({
                    params: {
                        lang: 'sc',
                        region: 'cn',
                        translate: ''
                    },
                    data: {
                        address: addressSelectCommon.areaNameCommon.split('-').join('') + addressSelectCommon.detailAddressCommon,
                        dataType: 'r01'
                    }
                })
                .then(res => {
                    if (res && res.data && res.data.code === 1) {
                        return true
                    }
                    return false
                })
            return result
        },
        // 查询地址
        async addressSearch() {
            if (!this.addressSelectCommon.areaNameCommon) {
                return
            }
            const flag = true
            // if (await this.outOfRange(this.addressSelectCommon)) {
            //     flag = await this.$confirm({
            //         content: `${this.addressText}件地址超范围，需要前往顺丰服务点自取`,
            //         okText: '继续查询',
            //         cancelText: '重新填写地址'
            //     })
            // }
            if (flag) {
                // 根据始发地地址查询网点代码
                this.addressSelectCommon.detailAddressCommon && (await this.queryDeptCode())
                if (!this.addressSelectCommon.detailAddressCommon) {
                    if (this.type === 'origin') {
                        this.srcZoneCode = ''
                    } else {
                        this.destZoneCode = ''
                    }
                }
                this.handleAddress()
                this.isShowDetailAddress = false
            }
        },
        handleAddress() {
            if (this.type === 'origin') {
                this.areaCodeOrigin = this.addressSelectCommon.code
                this.rateCodeOrigin = this.addressSelectCommon.rateCode
                this.countryCodeOrigin = this.addressSelectCommon.countryCode
                this.areaNameOrigin = this.addressSelectCommon.areaNameCommon
                this.areaOrigin = this.area
                this.cityCodeOrigin = this.addressSelectCommon.cityCode
                this.regionTabIndexO = this.regionTabIndex
                this.detailAddressOrigin = this.addressSelectCommon.detailAddressCommon
            } else {
                this.areaCodeDest = this.addressSelectCommon.code
                this.rateCodeDest = this.addressSelectCommon.rateCode
                this.countryCodeDest = this.addressSelectCommon.countryCode
                this.areaNameDest = this.addressSelectCommon.areaNameCommon
                this.areaDest = this.area
                this.cityCodeDest = this.addressSelectCommon.cityCode
                this.regionTabIndexD = this.regionTabIndex
                this.detailAddressDest = this.addressSelectCommon.detailAddressCommon
            }
        },
        detailAddressClose() {
            this.isShowDetailAddress = false
        },
        getRange() {
            const areaCode = this.areaCode
            Indicator.open()
            ajax.getInternalRange({
                params: {
                    areaCode
                }
            })
                .then(res => {
                    this.rangeData = res.data
                    this.isShowResult = true
                })
                .catch(() => {
                    this.isShowResult = false
                })
                .finally(() => {
                    Indicator.close()
                })
        },
        async getGlobalRange(code) {
            let valid = false
            const areaCode = this.areaCode
            Indicator.open()
            try {
                const res = await ajax
                    .getGlobalRange({
                        params: {
                            areaCode,
                            zipCode: code
                        }
                    })
                    .catch(err => {
                        if (err.response && (err.response.status === 404 || err.response.status === 403 || err.response.status === 0)) {
                            this.$toast('对不起，查询不到数据')
                        } else {
                            this.$toast('服务器暂不可用，请稍后再试')
                        }
                    })
                this.rangeData = res.data
                let areaName = [this.areaName, this.zipCode]
                if (areaName.endsWith('-')) {
                    areaName = areaName.slice(0, -1)
                }
                this.areaName = areaName
                valid = true
                this.isShowResult = true
            } catch (e) {
                valid = false
                this.isShowResult = false
            }
            Indicator.close()
            return valid
        },
        async getRegion({ code, level = -1 }) {
            // 获取国际省份信息
            const { data } = await ajax.getPriceOriginRegions({
                lang: 'sc',
                regiion: 'cn',
                translate: 'sc',
                data: {
                    code
                },
                params: {
                    level: -1
                }
            })
            return data
        },
        async getDestRegion({ code, level = -1 }) {
            // 获取国际省份信息
            const { data } = await ajax.getDestRegions({
                lang: 'sc',
                regiion: 'cn',
                translate: 'sc',
                data: {
                    code
                },
                params: {
                    level: -1,
                    originCode: code
                }
            })
            return data
        },
        async queryDeptCode() {
            const address = this.addressSelectCommon.areaNameCommon.split('-').join('') + this.addressSelectCommon.detailAddressCommon
            console.log(this.addressSelectCommon)
            await ajax
                .queryDeptCode({
                    params: {
                        lang: 'sc',
                        region: 'cn',
                        translate: '',
                        type: this.type === 'origin' ? 1 : 2,
                        cityCode: this.addressSelectCommon.rateCode,
                        address: encodeURIComponent(address),
                        villageMark: '1', // 返回行政村识别
                        villageDistMark: '1' // 返回行政村到乡镇的路线距离
                    }
                })
                .then(res => {
                    if (res && res.data && res.data.code === 0) {
                        if (this.type === 'origin') {
                            this.srcZoneCode = res.data.result.deptCode
                        } else {
                            this.destZoneCode = res.data.result.deptCode
                        }
                        this.villageFlag = res.data.result.villageFlag
                        this.villageTownDist = res.data.result.villageTownDist
                    } else {
                        if (this.type === 'origin') {
                            this.srcZoneCode = ''
                        } else {
                            this.destZoneCode = ''
                        }
                    }
                })
        },
        getPaymentCountry() {
            let paymentCountry = ''
            if (this.priceType === 'origin') {
                if (UIP.utils.check.AREA.isCHN(this.rateCodeOrigin)) {
                    paymentCountry = 'CN'
                } else {
                    paymentCountry = this.rateCodeOrigin
                }
            } else {
                if (UIP.utils.check.AREA.isCHN(this.rateCodeDest)) {
                    paymentCountry = 'CN'
                } else {
                    paymentCountry = this.rateCodeDest
                }
            }
            return paymentCountry
        },
        /**
         * @Author 80002393
         * @Description 获取标准
         * @parma
         * @Date 2019/9/11
         */
        query() {
            let flag = true
            if (!this.srcZoneCode || !this.destZoneCode) {
                flag = false
            }
            this.productList = []
            if (String(this.curShipType.code) === '2' && this.weight < 20) {
                return
            }
            if (!(this.areaNameOrigin && this.areaNameDest)) {
                return
            }
            const label = String(this.curShipType.code) === '1' && this.isIBU ? 7 : this.curShipType.code || 1
            const params = {
                timestamp: new Date().getTime(),
                label,
                origin: checkCountry.isIBU(this.countryCodeOrigin) ? this.countryCodeOrigin : this.areaCodeOrigin,
                dest: checkCountry.isIBU(this.countryCodeDest) ? this.countryCodeDest : this.areaCodeDest,
                originCityCode: checkCountry.isIBU(this.countryCodeOrigin) ? this.cityCodeOrigin : this.rateCodeOrigin,
                destCityCode: checkCountry.isIBU(this.countryCodeDest) ? this.cityCodeDest : this.rateCodeDest,
                srcZoneCode: flag ? this.srcZoneCode : '',
                destZoneCode: flag ? this.destZoneCode : '',
                weight: this.weight || '1',
                weightUnit: this.areaCodeOrigin === 'A000001000' ? 'lbs' : 'kg', // 美国为lbs
                postcode: this.zipCode || '',
                time: (this.time && this.time.replace('+08:00', '').replace('T', ' ')) || '',
                width: this.width,
                height: this.height,
                length: this.length,
                orderCount: '1',
                payMethod: this.priceType === 'origin' ? '1' : '2',
                paymentCountry: this.getPaymentCountry(),
                lang: 'sc',
                region: 'cn',
                translate: '',
                villageCode: this.villageFlag == null ? undefined : this.villageFlag,
                villageDistance: this.villageTownDist == null ? undefined : this.villageTownDist
            }
            //   Indicator.open('查询中')
            this.$loading('加载中')
            ajax.queryfreightPrice({
                params
            })
                .then(({ data }) => {
                    if (data && data.code === 0 && data.result && Object.keys(data.result).length > 0) {
                        const productPackServices = data.result.productPackServices || []
                        const productFreightPrices = data.result.productFreightPrices || []
                        this.productList = label === 8 ? productPackServices : productFreightPrices
                        this.arrangeDeliverDate()
                        this.arrangeFee()
                        this.appendAddtionalPayFee()
                        // 增加优惠价格的展示
                        this.appendRegionFreight()
                        if (this.quick.first) {
                            this.quick.show = true
                            UIP.sensor.track('QuickResearchView', {
                                event_name: '快问快答卡片展示',
                                flow: this.getFlow(),
                                research_type: '5',
                                good_weight: parseInt(this.weight) || 1,
                                good_volume: parseInt(this.width) * parseInt(this.height) * parseInt(this.length)
                            })
                        }
                    }
                })
                .catch(() => {
                    this.productList = []
                })
                .finally(() => {
                    // Indicator.close()
                    this.$loading()
                    this.showProRes = true
                })
        },
        /**
         * @description 增加优惠价格的展示
         * @param prices 接口返回的运费时效信息
         */
        appendRegionFreight(prices = this.productList) {
            // 时效产品是否包含T6的产品
            const includeT6 = prices.filter(item => item.limitTypeCode === PRODUCT.SF_EXPRESS_LAND_TRANSPORTATION)
            if (includeT6 && includeT6.length > 0) {
                prices.forEach(item => {
                    if (
                        [PRODUCT.SF_TODAY, PRODUCT.CITY_EXPRESS].indexOf(item.limitTypeCode) > -1 &&
                        item.totalFreight === includeT6[0].totalFreight &&
                        !item.regionFreight
                    ) {
                        item.regionFreight = -2
                    }
                    return item
                })
            }
        },
        /**
         * @description 整理显示的预计时效时间
         * @param prices 接口返回的运费时效信息
         */
        arrangeDeliverDate(prices = this.productList) {
            const late = '已过最晚收件时间'
            prices.forEach(item => {
                // 如果deliverTime则显示deliverTime
                if (item.reachTime) {
                    if (item.internet) {
                        item.deliverTimeText = `预计${item.reachTime}工作日送达`
                        return item
                    }
                    // 港澳台地区互寄显示时效为具体时间
                    if (item.orgionView === '2' && item.destView === '2') {
                        item.deliverTimeText = `预计${item.reachTime} 前送达`
                        return item
                    }
                    if (item.addTime) {
                        if (Date.parse(new Date(item.addTime).toString()) < Date.parse(new Date(item.reachTime).toString())) {
                            // 偏远区域加时
                            item.deliverTimeText = `${item.addTime}偏远区域加时`
                            return item
                        }
                        if (new Date(item.reachTime).toString() === 'Invalid Date') {
                            item.deliverTimeText = item.reachTime
                            return item
                        }
                        item.deliverTimeText = `预计${item.reachTime} 前送达`
                        return item
                    }
                    if (new Date(item.reachTime).toString() === 'Invalid Date') {
                        item.deliverTimeText = item.reachTime
                        return item
                    }
                    item.deliverTimeText = `预计${item.reachTime} 前送达`
                    return item
                }
                // deliverTime不存在则使用deliverTimeForType字段
                if (!item.internet) {
                    item.deliverTimeText = ''
                    const setDeliverTimeForType = new Map([
                        [
                            PRODUCT.SF_TODAY,
                            () => {
                                // 当日送达
                                item.deliverTimeText = item.reachTimeNotice
                                if (!item.deliverTimeText) {
                                    item.deliverTimeText = late
                                }
                            }
                        ],
                        [
                            PRODUCT.SF_NEXT_MORNING,
                            () => {
                                // 次早送达
                                item.deliverTimeText = late
                            }
                        ],
                        [
                            PRODUCT.SF_EXPRESS_LAND_TRANSPORTATION,
                            () => {
                                // 3-5工作日
                                item.deliverTimeText = '预计3-5工作日送达'
                                if (item.orgionView === '2' && item.destView === '2') {
                                    // 港澳台互寄的件,需要将港澳台件的时效去掉
                                    item.deliverTimeText = ''
                                }
                            }
                        ],
                        [
                            PRODUCT.SF_EXPRESS,
                            () => {
                                // 2-3工作日
                                item.deliverTimeText = '预计2-3工作日送达'
                                if (item.orgionView === '2' && item.destView === '2') {
                                    // 港澳台互寄的件,需要将港澳台件的时效去掉
                                    item.deliverTimeText = ''
                                }
                            }
                        ]
                    ]).get(item.limitTypeCode)
                    setDeliverTimeForType && setDeliverTimeForType()
                    return item
                }
            })
        },
        /**
         * @description 整理将要显示出来的费用
         * @param prices 接口返回的数据
         */
        arrangeFee(prices = this.productList) {
            const currencyNameText = '人民币'
            prices.forEach(item => {
                // 判断是否是大陆和港澳台互寄
                item.isChinaExpress =
                    (Number(item.originView) === 1 && Number(item.destView) !== 3) || (Number(item.originView) === 2 && Number(item.destView) !== 1)
                // 判断是否是大陆内的互寄
                item.isMainlandExpress = Number(item.originView) === 1 && Number(item.destView) === 1
                // （寄付并且大陆和港澳台互寄或大陆和大陆互寄）或者（到付并且大陆内互寄的情况显示总运费字段）
                const isOriginRMB = item.currencyName === currencyNameText
                const isDestRMB = item.destCurrencyName === currencyNameText
                item.currencyNameAbbr = isOriginRMB ? '¥' : item.currencyCode === 'USD' ? '$' : item.currencyCode || item.currencyName || '$'
                item.destCurrencyNameAbbr = isDestRMB ? '¥' : item.currencyCode === 'USD' ? '$' : item.currencyCode || item.currencyName || '$'
                // 基础运费
                const baseFreightTemp = Number(item.freight).toFixed(2)
                item.baseFreight = this.getFee(baseFreightTemp, item.currencyName)
                // 附加费用列表排序和翻译价格
                if (item.freightPriceItemList && item.freightPriceItemList.length > 0) {
                    item.freightPriceItemList.sort((a, b) => {
                        const aCode = serviceItemSortObj[a.code] || 99
                        const bCode = serviceItemSortObj[b.code] || 99
                        return aCode - bCode
                    })
                    item.freightPriceItemList.forEach(freightPrice => {
                        freightPrice.price = this.getFee(Number(freightPrice.price).toFixed(2), item.currencyName)
                    })
                }
                // 总运费
                const totalFreightTemp = item.totalFreight.toFixed(2)
                item.totalFreight = this.getFee(totalFreightTemp, item.currencyName)
                item.destTotalFreight = this.getFee(totalFreightTemp, item.destCurrencyName)
                // 总费用（运费+燃油费）
                const originFee = (item.freight + item.fuelCost).toFixed(2)
                const destFee = (item.destFreight + item.destFuelCost).toFixed(2)
                item.totalFee = this.getFee(originFee, item.currencyName)
                item.destTotalFee = this.getFee(destFee, item.currencyName)
                // 优惠的价格
                // item.regionFreight = `${item.regionFreight}`
                // 冷运（非人民币的情况需要加币种）
                // this.arrangeColdChainFee(item)
                // 处理未开通到付功能的国家
                // this.filterPrice(item)
                return item
            })
        },
        /**
         * @description 拼接冷运的费用
         * @param item 接口返回的一条数据
         */
        arrangeColdChainFee(item) {
            const transportationFee = '运输费'
            const pickupFee = '提货费'
            const deliveryFee = '配送费'
            const {
                pickupFreight,
                destPickupFreight,
                transportFreight,
                destTransportFreight,
                distributionFreight,
                destDistributionFreight,
                currencyName,
                destCurrencyName
            } = item
            // 提货费
            if (pickupFreight) {
                const fee = this.getFee(pickupFreight, currencyName)
                item.pickupFreight = `${pickupFee}：${fee}`
            }
            if (destPickupFreight) {
                const fee = this.getFee(destPickupFreight, destCurrencyName)
                item.destPickupFreight = `${pickupFee}：${fee}`
            }
            // 运输费
            if (transportFreight) {
                const fee = this.getFee(transportFreight, currencyName)
                item.transportFreight = `${transportationFee}：${fee}`
            }
            if (destTransportFreight) {
                const fee = this.getFee(destTransportFreight, destCurrencyName)
                item.destTransportFreight = `${transportationFee}：${fee}`
            }
            // 配送费
            if (distributionFreight) {
                const fee = this.getFee(distributionFreight, currencyName)
                item.distributionFreight = `${deliveryFee}：${fee}`
            }
            if (destDistributionFreight) {
                const fee = this.getFee(destDistributionFreight, destCurrencyName)
                item.destDistributionFreight = `${deliveryFee}：${fee}`
            }
        },
        /**
         * @description 拼接费用（非人民币的情况需要加币种）
         * @param fee 某一项费用
         * @param feeName 费用名称 比如配送费、提货费
         * @param currencyName 费用的单位
         */
        getFee(fee, currencyName) {
            return fee
            // const CNY = `元`
            // const currencyNameText = `人民币`
            // // 费用单位为[人民币]是替换为[元]，当返回值为CNY是则不用替换
            // currencyName = currencyName === currencyNameText ? '' : currencyName
            // if (fee) {
            //     // 英文的币种名称放在金额前，[起]字放在最后，翻译成英文为discount放在开头
            //     fee = `${currencyName}${fee}${!currencyName ? CNY : '' }起`
            // }
            // return fee
        },
        /**
         * @description 判断根据流向是否添加附加活动
         * @param price 接口返回的运费时效信息
         */
        appendAddtionalPayFee(prices = this.productList) {
            const addition = additionalServiceList.filter(item => item.switch)
            if (!addition.length) {
                return
            }
            prices.forEach(price => {
                const originCountryCode = this.countryCodeOrigin
                const destsCountryCode = this.countryCodeDest
                const additionalService = additionalServiceList.filter(item => {
                    const available = this.additionalAvailableAtLocation(item, originCountryCode, destsCountryCode)
                    if (available) {
                        if (item.code === 'overdue-refund') {
                            return item.availableService.indexOf(price.limitTypeCode) !== -1
                        }
                        if (item.code === 'earlier-shipping-lower-price') {
                            return price.regionFreight !== 0
                        }
                        return false
                    }
                    return false
                })
                price.additionalService = additionalService || []
            })
        },
        /**
         * @description 格局countryCode判断是否在附加服务流向内
         * @param additionalPayFee  附加服务列表
         * @param originCountryCode 寄方countryCode
         * @param destsCountryCode  收方countryCode
         */
        additionalAvailableAtLocation(additionalPayFee, originCountryCode, destsCountryCode) {
            const originLocations = additionalPayFee.originLocations
            const destsLocations = additionalPayFee.destsLocations
            const originAvailable = originLocations.indexOf(originCountryCode) >= 0
            const destsAvailabel = destsLocations.indexOf(destsCountryCode) >= 0
            return additionalPayFee.bothRequired ? originAvailable && destsAvailabel : originAvailable || destsAvailabel
        },
        getFlow() {
            const originCityCode = checkCountry.isIBU(this.countryCodeOrigin) ? this.cityCodeOrigin : this.rateCodeOrigin
            const destCityCode = checkCountry.isIBU(this.countryCodeDest) ? this.cityCodeDest : this.rateCodeDest
            return `${originCityCode}-${destCityCode}`
        },
        quickChoose(type) {
            this.quick.result = type
            UIP.sensor.track('QuickResearchClick', {
                event_name: '快问快答卡片_选择回答',
                result: type === 'no' ? '不满意' : '棒棒哒',
                flow: this.getFlow(),
                research_type: '5',
                good_weight: parseInt(this.weight) || 1,
                good_volume: parseInt(this.width) * parseInt(this.height) * parseInt(this.length)
            })
            if (type === 'yes') {
                this.quick.first = false
                this.$toast('感谢您的参与！')
                setTimeout(() => {
                    this.quick.show = false
                }, 3000)
            }
        },
        // 不满意标签
        getNoReason(reason) {
            this.quick.reason[reason] = !this.quick.reason[reason]
        },
        // 快问快答提交
        quickQuestionSubmit() {
            const { trouble, wrong, expensive, other } = this.quick.reason
            if (!trouble && !wrong && !expensive && !other) {
                this.$toast('请选择不满意原因')
                return
            }
            let result = ''
            if (trouble) {
                result += '操作麻烦；'
            }
            if (wrong) {
                result += '结果有误；'
            }
            if (expensive) {
                result += '费用太贵；'
            }
            if (expensive) {
                result += `其他：${other}`
            }
            UIP.sensor.track('QuickResearchSubmitClick', {
                event_name: '快问快答卡片_点击提交',
                flow: this.getFlow(),
                result,
                research_type: '5',
                good_weight: parseInt(this.weight) || 1,
                good_volume: parseInt(this.width) * parseInt(this.height) * parseInt(this.length)
            })
            this.quick.first = false
            this.$toast('提交成功，感谢您的反馈！')
            setTimeout(() => {
                this.quick.show = false
            }, 3000)
        },
        // 展示费用明细
        showMoreFreight(item) {
            this.showPriceDetailProduct = item
        },
        // 获取冷运规则描述
        getTipDes(product) {
            return (
                new Map([
                    ['SE0113', '主打0-50kg'],
                    ['SE003001', '主打50-500kg'],
                    ['SE0030', '主打500kg+']
                ]).get(product.productCode) || ''
            )
        }
    }
}
</script>

<style lang="scss" scoped>
.header-height {
    min-height: 60%;
}
.no-header {
    min-height: 100%;
}
.accept-page {
    background: $gray-lighter;
    margin-bottom: 20px;
    .result-btn {
        background: #ffffff;
        border: 1px solid #ebebeb;
        height: 130px;
        padding: 22px 0;
        .btn {
            height: 86px;
            line-height: 86px;
            margin: auto;
            width: 300px;
            background: #dc1e32;
            border-radius: 100px;
            font-size: 34px;
            color: #ffffff;
            text-align: center;
        }
    }
    .result-wrap {
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        .result-item {
            background: #f9f9f9;
            border: 1px solid #f3f3f3;
            border-radius: 8px;
            margin: 44px;
            padding: 23px;
            .item {
                .item-title {
                    margin-top: 18px;
                    font-size: 28px;
                    /* font-weight: bold; */
                    color: #333333;
                    letter-spacing: 0;
                    line-height: 44px;
                }
                .item-des {
                    font-size: 26px;
                    color: #151515;
                    letter-spacing: 0;
                    line-height: 44px;
                }
            }
        }
    }
    .head2 {
        background: #f2f2f2;
        &:after {
            content: '';
            display: table;
        }
    }
    .description {
        font-size: 0.24rem;
        display: block;
        height: 0.54rem;
        line-height: 0.54rem;
        text-align: right;
        padding-right: 0.55rem;
        background: $yellow-dark;
        color: $white;
        opacity: 0.7;
        span {
            padding-right: 0.2rem;
        }
    }
    .detail {
        background: #ffffff;
        border-radius: 0.08rem;
        border-radius: 0.08rem;
        margin: 0.24rem;
        padding: 0 0.2rem;
        .detail-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.06);
            height: 0.96rem;
            position: relative;
            .left {
                width: 1.8rem;
            }
            .right {
                font-weight: bold;
                flex-grow: 1;
                text-align: right;
                .zip-input {
                    border: 0;
                    text-align: right;
                    font-weight: bold;
                }
                .icon-right {
                    height: 0.2rem;
                    position: absolute;
                    right: 0;
                    top: 0.42rem;
                    color: #ccc;
                }
                .tiji {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    .wrap {
                        height: 0.76rem;
                        width: 1.54rem;
                        background: #f9f9f9;
                        border-radius: 0.08rem;
                        text-align: center;
                        line-height: 0.76rem;
                        input {
                            padding: 0;
                            margin: 0;
                            border: 0;
                            width: 0.96rem;
                            height: 0.4rem;
                            display: inline-block;
                            background: #f9f9f9;
                            text-align: right;
                            font-size: 0.28rem;
                            color: #333333;
                            text-align: center;
                            font-weight: bold;
                        }
                    }
                }
                .count {
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    .act {
                        font-size: 0.5rem;
                        width: 0.5rem;
                        height: 0.5rem;
                        line-height: 0.5rem;
                        /* font-weight: bold; */
                    }
                    .t-l {
                        text-align: left;
                    }
                    span {
                        display: inline-block;
                    }
                    .wrap {
                        width: 2.28rem;
                        height: 0.76rem;
                        background: #f9f9f9;
                        border-radius: 0.08rem;
                        text-align: center;
                        line-height: 0.76rem;
                        .unit {
                            font-size: 0.28rem;
                            color: #333333;
                            font-weight: bold;
                        }
                        input {
                            padding: 0;
                            margin: 0;
                            border: 0;
                            width: 1rem;
                            height: 0.4rem;
                            display: inline-block;
                            background: #f9f9f9;
                            text-align: right;
                            font-size: 0.28rem;
                            color: #333333;
                            font-weight: bold;
                        }
                    }
                }
            }
        }
    }
    .address {
        margin: 0.24rem;
        margin-top: 0;
        display: flex;
        flex-direction: column;
        background: $white;
        border-radius: 0.08rem;
        box-shadow: 0 0.04rem 0.32rem 0 rgba(0, 0, 0, 0.08);
        position: relative;
        .address-wrap {
            height: 1.25rem;
            position: relative;
            display: flex;
            align-items: center;
            span {
                display: inline-flex;
                font-size: 0.24rem;
                /* font-weight: bold; */
                width: 0.36rem;
                height: 0.36rem;
                align-items: center;
                justify-content: center;
                border-radius: 0.04rem;
                margin: 0 0.2rem;
                &.p-holder {
                    width: 1.4rem;
                    color: #ccc;
                    position: absolute;
                    font-size: 0.3rem;
                    color: #666;
                    letter-spacing: 0;
                    left: 0.56rem;
                    text-align: left;
                    display: inline-block;
                }
                &.sender {
                    background: $black;
                    color: $white;
                }
                &.receiver {
                    background: $red;
                    color: $white;
                }
            }
            .input {
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                flex: 1;
                color: $gray-light;
                padding-left: 1.6rem;
                font-size: 0.28rem;
                color: #333333;
                text-align: right;
                padding-right: 0.5rem;
                /* font-weight: bold; */
                &.active {
                    color: $black;
                }
            }
            &:first-of-type {
                .input {
                    border-bottom: 0.02rem solid $gray-lighter;
                }
            }
        }
        .ico-right {
            height: 0.2rem;
            position: absolute;
            right: 0.2rem;
            top: 0.5rem;
            color: $gray-light;
        }
        img {
            position: absolute;
            height: 0.6rem;
            top: 0.95rem;
            left: 0.36rem;
        }
    }
    .p-select {
        right: 0.5rem;
        position: absolute;
        color: #ccc;
    }
    .sel-reigin {
        padding: 0 0.3rem;
        line-height: 1rem;
        background: #fff;
        label {
            display: flex;
            align-items: baseline;
            position: relative;
            top: -0.6rem;
        }
        .title {
            font-weight: 600;
        }
        .txt {
            background: #fff;
            display: inline-block;
            color: #868686;
            text-align: left;
            flex: 1;
            margin-right: 0.2rem;
            border: 1px solid #d9d9d9;
            border-radius: 0.08rem;
            box-shadow: 0 0.1rem 0.24rem 0 rgba(0, 0, 0, 0.06);
            padding-left: 0.24rem;
            padding-right: 0.3rem;
            &.active {
                color: $black;
            }
        }
        .caret-right {
            position: absolute;
            top: 50%;
            right: 0.5rem;
            margin-top: -0.06rem;
            width: 0;
            height: 0;
            border: 0.11rem solid transparent;
            border-top: 0.11rem solid black;
        }
    }
    .demo-tip {
        margin: 0.24rem;
        font-size: 0.26rem;
    }
    .button-wrapper {
        text-align: center;
        margin-top: 0.4rem;
        .primary-btn {
            font-weight: bold;
            height: 0.86rem;
            width: 4rem;
            min-width: 4rem;
            line-height: 0.86rem;
            letter-spacing: 1px;
            background-color: #dc1e32;
        }
    }
    .select {
        width: 100%;
        font-size: 0.3rem;
        .title {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
        }
        .top {
            height: 0.84rem;
            color: #111111;
            padding: 0 0.48rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .svg-icon {
                width: 0.4rem;
            }
            a {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 0.8rem;
                height: 0.8rem;
            }
        }
        .bottom {
            height: 0.84rem;
            display: flex;
            padding-left: 0.64rem;
            color: $red;
            align-items: stretch;
            border-bottom: 0.04rem solid $gray-lighter;
            span {
                display: flex;
                align-items: center;
                border-bottom: 0.04rem solid $red;
                position: relative;
                top: 0.04rem;
            }
        }
        .error {
            height: 30vh;
            line-height: 30vh;
            text-align: center;
        }
    }
    .overlay-service {
        position: fixed;
        top: 70%;
        right: 0.1rem;
        width: 1rem;
        height: 1rem;
        background-color: #fff;
        box-shadow: 0 0 0.13rem 3px rgba(0, 0, 0, 0.1);
        padding: 0.1rem 0;
        z-index: 10;
        >>> a {
            display: block;
            width: 100%;
        }
        p {
            font-size: 5px;
            color: 666;
            &::before {
                content: '';
                display: block;
                width: 0.5rem;
                height: 0.5rem;
                margin: 0 0 0 auto;
                background: url('~@/assets/images/logo/sf-logo.png') 0 0 / 0.4rem 0.4rem no-repeat;
            }
        }
    }
    .rgn-tab {
        li {
            display: inline-block;
            width: 33.3%;
            text-align: center;
            line-height: 2;
            padding: 0.2rem;
        }
        .btn-tab {
            width: 80%;
            margin: 0 auto;
            background: #fff;
            border-radius: 0.3rem;
            font-size: 0.26rem;
            box-sizing: border-box;
            border: solid 0.01rem #e4e4e4;
            &.active {
                color: #dc1e32;
                border: solid 0.01rem #dc1e32;
                background: #fff;
            }
        }
    }
    .rst-range {
        padding: 0 0.71rem 0 0.64rem;
        background: $white;
        .tip {
            font-size: 0.26rem;
            line-height: 0.52rem;
            color: #888888;
            text-align: left;
            &.all-range {
                font-size: 0.3rem;
                line-height: 0.6rem;
                color: #0dbf0b;
                .icon-all-range {
                    display: inline-block;
                    vertical-align: middle;
                    width: 0.36rem;
                    height: 0.36rem;
                    background: url('~@/assets/svg/all-range.svg') center / cover;
                    margin-right: 0.11rem;
                    margin-top: -0.06rem;
                }
            }
            &.part-range {
                font-size: 0.28rem;
                line-height: 0.6rem;
                color: #dc1e32;
                .icon-part-range {
                    display: inline-block;
                    vertical-align: middle;
                    width: 0.36rem;
                    height: 0.36rem;
                    background: url('~@/assets/svg/part-range.svg') center / cover;
                    margin-right: 0.11rem;
                    margin-top: -0.06rem;
                }
            }
        }
        .pane {
            margin-bottom: 0 0.3rem;
        }
    }
    h3 {
        padding: 0.3rem;
        text-indent: 2ch;
        font-size: 0.3rem;
        color: #111111;
        font-weight: 800;
        box-shadow: 0 1px 0 0 #f2f2f2;
    }
    h5 {
        font-size: 0.26rem;
        color: #333333;
        /* font-weight: bold; */
        line-height: 3;
        width: 100%;
    }
    -webkit-overflow-scrolling: touch;
    .price-result {
        margin: 0 0.2rem;
        margin-top: 0.6rem;
        padding-bottom: 0.2rem;
        .des {
            font-size: 0.26rem;
            color: #999999;
            padding-bottom: 0.18rem;
        }
        .list {
            background: #fff;
            padding: 0.2rem 0 0 0;
            border-radius: 0.08rem;
            .no-data {
                height: 1.67rem;
                line-height: 1.67rem;
                font-size: 0.3rem;
                color: #333333;
                letter-spacing: 0;
                text-align: center;
            }
            .others {
                height: 0.96rem;
                line-height: 0.96rem;
                margin: 0 0.2rem;
                box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.06);
                font-size: 0.28rem;
                color: #666666;
                position: relative;
                border-top: 1px solid rgba(0, 0, 0, 0.06);
                .ico-right {
                    height: 0.2rem;
                    position: absolute;
                    right: 0rem;
                    top: 0.4rem;
                    color: $gray-light;
                }
                .over {
                    width: 0.22rem;
                    position: absolute;
                    left: 1.78rem;
                    top: 0.35rem;
                }
            }
            .tip {
                background: #fcf4dd;
                font-size: 0.24rem;
                color: #f48944;
                line-height: 0.6rem;
                height: 0.6rem;
                padding-left: 0.56rem;
                background: url('~@/assets/images/price/tip.png') no-repeat;
                background-size: 0.26rem 0.22rem;
                background-position: 0.2rem center;
            }
            .tab {
                font-size: 0.3rem;
                color: #333333;
                border-bottom: 1px solid #f3f3f3;
                position: relative;
                margin: 0 0.2rem;
                .left {
                    display: flex;
                    width: 4.58rem;
                    justify-content: space-between;
                }
                .tab-item {
                    padding-bottom: 0.06rem;
                    border-bottom: 0.04rem solid transparent;
                    margin-bottom: -0.02rem;
                    font-weight: bold;
                    &.active {
                        color: #dc1e32;
                        border-color: #dc1e32;
                    }
                }
                .price-type {
                    width: 0.8rem;
                    height: 0.3rem;
                    font-size: 0.26rem;
                    color: #333;
                    letter-spacing: 0;
                    line-height: 0.3rem;
                    position: absolute;
                    right: 0.24rem;
                    top: 0.1rem;
                    text-align: right;
                    background: url('~@/assets/images/price/change.png') no-repeat;
                    background-position: left center;
                    background-size: 0.18rem;
                }
            }
            .product {
                margin: 0 0.2rem;
                padding: 0.3rem 0;
                padding-bottom: 0;
                .red {
                    color: #dc1e32;
                }
                .product-item {
                    position: relative;
                    padding: 0.4rem 0.24rem 0.3rem 0.24rem;
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    align-items: baseline;
                    box-shadow: 0 0.01rem 0.09rem 0 rgba(0, 0, 0, 0.06);
                    border-radius: 0.08rem;
                    overflow: hidden;
                    margin-bottom: 0.2rem;
                    &:last-child {
                        margin-bottom: 0;
                    }
                    .name-wrap {
                        position: absolute;
                        top: 0;
                        left: -0.2rem;
                        .name {
                            background: #ffe7ea;
                            font-size: 0.22rem;
                            color: #dc1e32;
                            letter-spacing: 0;
                            height: 0.4rem;
                            line-height: 0.4rem;
                            padding: 0 0.44rem;
                            transform: skewX(-45deg);
                            span {
                                transform: skewX(45deg);
                                display: inline-block;
                                font-weight: bold;
                            }
                        }
                        img {
                            display: inline-block;
                            width: 0.22rem;
                            /* float: right; */
                            position: absolute;
                            right: -0.45rem;
                            top: 0.1rem;
                        }
                    }
                    .left {
                        font-size: 0.28rem;
                        color: #333333;
                        width: 55%;
                        font-weight: bold;
                    }
                    .right {
                        font-size: 0.28rem;
                        color: #333333;
                        letter-spacing: 0;
                        width: 43%;
                        text-align: right;
                        margin-left: 2%;
                        .unit {
                            font-size: 0.34rem;
                            color: #dc1e32;
                            font-weight: bold;
                        }
                        .price {
                            font-size: 0.5rem;
                            color: #dc1e32;
                            font-weight: bold;
                        }
                    }
                    .introduce {
                        font-size: 0.24rem;
                        color: #808080;
                        line-height: 0.28rem;
                        width: 100%;
                    }
                    .freight-button {
                        display: flex;
                        align-items: center;
                        font-size: 0.24rem;
                        color: #808080;
                        margin-top: 0.1rem;
                    }
                    .icon-information {
                        width: 0.25rem;
                        height: 0.25rem;
                        margin-left: 0.12rem;
                    }
                    .tip-des {
                        margin-left: 0.2rem;
                        background-color: #f5f5f5;
                        border-radius: 8px;
                        color: #999999;
                        padding: 0 0.08rem;
                    }
                }
            }
        }
    }
    .quick-question-ask {
        margin: 0.2rem;
        padding: 0 0.2rem;
        background: #ffffff;
        box-shadow: 0px 0.04rem 0.32rem 0 rgba(0, 0, 0, 0.02);
        border-radius: 0.08rem;
        &:before,
        &:after {
            content: '';
            display: table;
        }
        & > .title {
            margin-top: 0.39rem;
            text-align: center;
        }
        .choose {
            margin-top: 0.48rem;
            display: flex;
            justify-content: center;
            .no,
            .yes {
                display: flex;
                align-items: center;
                width: 2.16rem;
                height: 0.64rem;
                color: #333334;
                background: #f8f8f8;
                border: 0.02rem solid #f2f2f2;
                border-left: 0;
                border-radius: 1rem;
                &.active {
                    color: #ed042e;
                    border-color: #ed042e;
                }
                .icon {
                    width: 0.72rem;
                    height: 0.72rem;
                    background-size: contain;
                    background-repeat: no-repeat;
                    border-radius: 50%;
                }
                p {
                    padding-left: 0.16rem;
                    font-size: 0.32rem;
                    text-align: center;
                    font-weight: 500;
                }
            }
            .no {
                &.mr-8 {
                    margin-right: 0.8rem;
                }
                margin-bottom: 0.56rem;
                .icon {
                    background-image: url('~@/assets/images/price/face-no.png');
                }
            }
            .yes {
                margin-bottom: 0.7rem;
                .icon {
                    background-image: url('~@/assets/images/price/face-yes.png');
                }
            }
        }
        .no-reason {
            .title {
                display: flex;
                align-items: center;
                .line {
                    width: 0;
                    flex: 1;
                    height: 0.02rem;
                    background: #d8d8d8;
                }
                p {
                    margin-left: 0.12rem;
                    margin-right: 0.08rem;
                }
            }
            .btns {
                padding: 0.4rem 0;
                display: flex;
                justify-content: space-between;
                button {
                    width: 2.02rem;
                    height: 0.72rem;
                    color: #333;
                    background: rgba(255, 255, 255, 0.1);
                    border: 1px solid #e4e4e4;
                    border-radius: 0.36rem;
                    &.active {
                        color: #dc1e32;
                        border-color: #dc1e32;
                    }
                }
            }
            .other {
                margin-bottom: 0.16rem;
                font-size: 0.28rem;
                color: #333333;
            }
            .other-detail {
                display: flex;
                flex-direction: column;
                padding: 0.12rem 0.19rem;
                height: 1.56rem;
                background: #f9f9f9;
                textarea {
                    flex: 1;
                    font-size: 0.26rem;
                    background: #f9f9f9;
                    resize: none;
                    border: none;
                }
                p {
                    font-size: 0.26rem;
                    color: #cccccc;
                    text-align: right;
                    font-weight: 400;
                }
            }
            .submit {
                display: block;
                margin: 0.32rem auto 0.44rem;
                width: 2.5rem;
                height: 0.86rem;
                font-size: 0.34rem;
                color: #ffffff;
                background: #dc1e32;
                border: 0;
                border-radius: 0.41rem;
            }
        }
    }
    .freight-detail {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 9999;
        background-color: rgba(0, 0, 0, 0.4);
        .center-middle {
            max-width: 6.4rem;
            width: 6.4rem;
            background: #fff;
            color: #000;
            text-align: center;
            z-index: 9999;
            position: absolute;
            left: 50%;
            top: 50%;
            min-height: 4.4rem;
            border-radius: 0.26rem;
            transform: scale(1, 1) translate(-50%, -50%);
            padding: 0.56rem 0 0.32rem;
            h4 {
                text-align: center;
                font-weight: bold;
                font-size: 0.36rem;
                color: #0f1214;
            }
            .freight-wrap {
                height: 2.5rem;
                overflow-y: auto;
                padding: 0 0.4rem;
                .detail-item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    font-size: 0.28rem;
                    color: #0f1214;
                    margin-top: 0.04rem;
                    & span:first-child {
                        color: #808080;
                    }
                }
            }
            .freight-close {
                font-weight: bold;
                font-size: 0.34rem;
                text-align: center;
                color: #ff3a3a;
                padding-top: 0.2rem;
                border-top: 1px solid #f2f4f4;
            }
        }
    }
}
.overlay-ship {
    background: #ffffff;
    border: 1px solid #cccccc;
    box-shadow: 0 0 0.14rem 0 rgba(0, 0, 0, 0.08);
    font-size: 0.3rem;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
    line-height: 0.83rem;
    height: 0.83rem;
    width: 1.94rem;
    border-radius: 1rem 0rem 0 1rem;
    text-align: left;
    position: relative;
    padding-left: 0.26rem;
    .icon-right {
        height: 0.2rem;
        position: absolute;
        right: 0;
        top: 0.31rem;
        color: #333;
        right: 0.1rem;
    }
}
.btn-confirm {
    padding: 0.2rem 0.5rem;
    >>> span {
        display: inline-block;
        width: 100%;
        border-radius: 0.48rem;
        text-align: center;
        color: #fff;
        font: bold 0.34rem/3 YaHei;
        letter-spacing: 0.5rem;
        text-indent: 0.5rem;
        background: rgba(0, 0, 0, 0.3);
    }
    &.active {
        >>> span {
            background: #dc1e32;
            color: #ffffff;
        }
    }
}
::-webkit-scrollbar {
    display: none;
}
.search-form {
    position: relative;
    margin: 0.2rem 0.3rem 0;
    width: calc(100% - 0.6rem);
    height: 0.64rem;
    .icon-search {
        position: absolute;
        display: inline-block;
        left: 0.2rem;
        top: 0.18rem;
        width: 0.32rem;
        height: 0.32rem;
        background: url('~@/assets/images/ico/icon-search-gray.png') no-repeat;
        background-size: cover;
    }
    .icon-close {
        position: absolute;
        display: inline-block;
        right: 0.3rem;
        top: 0.18rem;
        width: 0.3rem;
        height: 0.3rem;
        background-size: cover;
        background: url('~@/assets/images/ico/icon-close-new.png') no-repeat;
    }
}
input[type='text'] {
    position: relative;
    padding: 0 0.7rem 0 0.57rem;
    border: none;
    font-size: 0.26rem;
    color: $black;
    background-color: $bg-color;
    border-radius: 0.32rem;
    line-height: 0.64rem;
}
.search-address-region {
    padding-top: 0.32rem;
    max-height: 7rem;
    overflow-y: scroll;
    li {
        width: 100%;
        min-height: 0.96rem;
        line-height: 0.96rem;
        padding: 0.26rem 0.44rem;
        font-size: 0.3rem;
        line-height: 0.42rem;
        &:nth-child(odd) {
            background-color: #f9f9f9;
        }
        &.active {
            color: rgba(226, 12, 12, 0.842);
            &::before {
                content: '\2714';
                position: relative;
                float: right;
            }
        }
    }
}
.search-address-null {
    padding-top: 0.32rem;
    span {
        display: inline-block;
        width: 100%;
        line-height: 0.96rem;
        padding: 0.26rem 0.44rem;
        font-size: 0.3rem;
        line-height: 0.42rem;
    }
}
.result {
    width: 100%;
    max-height: 100%;
    background: $white;
    display: flex;
    flex-direction: column;
    .warmTip {
        padding: 0 0.32rem;
        padding-bottom: 22px;
        font-size: 0.22rem;
        color: $red;
    }
    .title {
        font-size: 0.3rem;
        /* font-weight: bold; */
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-shrink: 0;
        height: 0.84rem;
        color: #111111;
        padding: 0 0.48rem;
        .svg-icon {
            width: 0.4rem;
        }
        a {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 0.8rem;
            height: 0.8rem;
        }
    }
}
table {
    width: 100%;
    font-size: 0.28rem;
    td {
        width: 25%;
        text-align: center;
        padding: 0.15rem 0;
        border: 0.01rem solid $gray-lighter;
    }
    tr {
        &:nth-of-type(odd) {
            background: #fcfcfc;
        }
    }
}
.table-title-wrapper {
    margin-top: 0.21rem;
    height: 0.95rem;
    box-sizing: content-box;
}
.table-title {
    height: 0.95rem;
    display: flex;
    align-items: stretch;
    background: #fcfcfc;
    font-size: 0.3rem;
    /* font-weight: bold; */
    border-top: 0.01rem solid $gray-lighter;
    span {
        width: 25%;
        display: flex;
        align-items: center;
        justify-content: center;
        &:not(:first-of-type) {
            border-left: 0.01rem solid $gray-lighter;
        }
    }
}
.cup {
    height: 0.24rem;
    background: #f1f1f1;
}
.no-result {
    margin-top: 0.27rem;
    padding: 0.27rem 0.25rem;
    background: $white;
    color: $red;
}
.load-more-wrapper {
    flex: 1;
    overflow: auto;
}
.load-tip {
    text-align: center;
    height: 0.7rem;
    line-height: 0.7rem;
}
.detail-ddress {
    position: absolute;
    z-index: 20;
    width: 100%;
    background: #f6f6f6;
    height: 100%;
    bottom: 0;
    .address-title {
        background: #fff;
        margin-bottom: 0.2rem;
        padding: 0.2rem;
        color: #151515;
        display: flex;
        align-items: center;
        .address-close {
            position: relative;
            width: 0.5rem;
            height: 0.5rem;
            flex: 1;
            &:before {
                position: absolute;
                top: 50%;
                content: '';
                display: block;
                height: 5px;
                width: 0.36rem;
                background: #000;
                transform: rotate(45deg);
            }
            &:after {
                position: absolute;
                top: 50%;
                content: '';
                display: block;
                height: 5px;
                width: 0.36rem;
                background: #000;
                transform: rotate(-45deg);
            }
        }
        .title-text {
            width: 80%;
            text-align: center;
            font-size: 0.39rem;
        }
        .blank {
            flex: 1;
        }
    }
    .address-select {
        position: relative;
        .address-wrap {
            height: 1rem;
            .ico-right {
                top: 0.4rem;
            }
            .p-holder {
                margin: 0;
            }
        }
        textarea {
            background: #fff;
            border-radius: 0;
            height: 1rem;
            position: relative;
            padding: 0.28rem 0.7rem 0.28rem 0.57rem;
            border: none;
            font-size: 0.26rem;
            color: #333;
            resize: none;
        }
        i {
            display: inline-block;
            position: absolute;
            right: 0.18rem;
            bottom: 0.4rem;
            width: 0.32rem;
            height: 0.32rem;
            background: url('~@/assets/images/ico/icon-location.png') no-repeat;
            background-size: cover;
        }
    }
    .address-search {
        background-color: #fff;
        position: fixed;
        bottom: 0;
        height: 1.3rem;
        width: 100%;
    }
}
.fade-enter-active,
.fade-leave-active {
    bottom: 0;
    opacity: 1;
    transition: all 0.3s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
    bottom: -100vh;
}
</style>

<style lang="scss">
.search-address-region {
    li {
        i {
            display: inline-block;
            color: $red;
            font-style: normal;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/price/index.vue